import { css } from "styled-components";
import { buildRulesets } from "./buildRulesets";
import "../designTokens/variables.css";

const fontFamily = css`
  font-family: var(--font-family-alpha);
`;

const textStyleToSizeMapping = {
  headline1: css`
    font-weight: var(--font-weight-light);
    font-size: var(--size-font-xxlarge);
    letter-spacing: var(--letter-spacing-widest);
  `,
  headline2: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-extralarge);
    letter-spacing: var(--letter-spacing-wide);
  `,
  headline3: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-large);
    letter-spacing: var(--letter-spacing-wide);
  `,
  headline4: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-mediumlarge);
    letter-spacing: var(--letter-spacing-wide);
  `,
  subtitle1: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-medium);
    letter-spacing: var(--letter-spacing-wider);
  `,
  subtitle2: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-medium);
    letter-spacing: var(--letter-spacing-wider);
  `,
  subtitle3: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
  `,
  body1: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
  `,
  body2: css`
    font-weight: var(--font-weight-semibold);
    font-size: var(--size-font-small);
    letter-spacing: var(--letter-spacing-tighter);
  `,
  body3: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-small);
    letter-spacing: var(--letter-spacing-tighter);
  `,
  caption: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-extrasmall);
    letter-spacing: var(--letter-spacing-tight);
  `,
};

const rulesets = buildRulesets({ fontFamily, textStyleToSizeMapping });

export const {
  primaryActive,
  primaryInactive,
  primaryDisabled,
  link,
  linkDisabled,
  warning,
  error,
  success,
  whiteActive,
  whiteInactive,
  whiteDisabled,
} = rulesets;
